<template>
  <button
    class="poi-button"
    @click="handleClick"
    :disabled="buttonDisabled || loading"
    :autofocus="autofocus"
    :type="nativeType"
    :class="[
      bthDom&&bthDom,
      type ? 'poi-button--' + type : '',
      buttonSize ? 'poi-button--' + buttonSize : '',
      {
        'is-disabled': buttonDisabled,
        'is-loading': loading,
        'is-plain': plain,
        'is-round': round,
        'is-circle': circle,
        'poi-button--prefix': $slots.prefix,
        'poi-button--suffix': $slots.suffix
      }
    ]"

    :style="fstyle"
  >

    <!-- 前置内容 -->
    <span class="poi-button__prefix" v-if="$slots.prefix">
      <slot name="prefix"></slot>
    </span>

    <!-- 后置内容 -->
    <span class="poi-button__suffix" v-if="$slots.suffix">
      <slot name="suffix"></slot>
    </span>
    
    <i class="poi-icon-loading iconfont" v-if="loading"></i>
    <i class="iconfont" :class="icon" v-if="icon && !loading"></i>
    <span v-if="$slots.default"><slot></slot></span>
  </button>
</template>
<script>
  export default {
    name: 'poi-button',

    inject: {
      elForm: {
        default: ''
      },
      elFormItem: {
        default: ''
      }
    },

    props: {
      type: {
        type: String,
        default: 'default'
      },
      size: String,
      icon: {
        type: String,
        default: ''
      },
      nativeType: {
        type: String,
        default: 'button'
      },
      loading: Boolean,
      disabled: Boolean,
      plain: Boolean,
      autofocus: Boolean,
      round: Boolean,
      circle: Boolean,

      //接收自定义属性
      freestyle: {
        type: null
      }
    },

    data(){
      return{
        // bthDom:`bth-${fstyleDom}`,
        bthDom:null,
      }
    },

    computed: {
      _elFormItemSize() {
        return (this.elFormItem || {}).elFormItemSize;
      },
      buttonSize() {
        return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      },
      buttonDisabled() {
        return this.disabled || (this.elForm || {}).disabled;
      },

      //将自定义样式加入到属性中
      fstyle() {
        if (this.freestyle) {
          this.bthDom = `bth-${Math.random().toFixed(4).replace('.','')}`;
          var styleEl = document.styleSheets[1];
          this.freestyle.btnstyle.forEach((item, index) => {
            styleEl.insertRule(`.${this.bthDom}${item}`, styleEl.rules.length);
          });
        }
        //styleSheet.insertRule(this.freestyle);
      }
    },

    methods: {
      handleClick(evt) {
        this.$emit('click', evt);
      }
    }
  };
</script>
